import React , {useRef} from 'react';
import '../Components/contactus.css';
import emailjs from 'emailjs-com';
import { Slide } from 'react-reveal';

 

function ContactUs() {



  return (
    <div className='contactContainer' id='contact'>
    <Slide top>
    <h1>CONTACT US</h1>
    </Slide>
    <Slide bottom>
        <form action=""  >
            <input type="text" placeholder='Full Name' required />
            <input type="email" name='email_from' placeholder='Write Your Email' required />
            <textarea name="message" id="" cols="30" rows="10" placeholder='Write Your Message' required></textarea>
            {/* <input type="submit" value='Send' /> */}
            <button className='contactBtn'>Send</button>
        </form>
        </Slide>

        </div>
  )
}

export default ContactUs